module.exports = __webpack_public_path__ + "img/football-promotions.f7c06555.png";